import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    deleteFilterPAEAA010Conditions,
    fetchInitialConditions,
    saveFilterPAEAA010Conditions,
    saveMatchingConditions,
} from '../../../redux/reducers/PAEAA010';
import { getPAAAA010recruit, getPAEAA010search, postPAEAA010list, putPAAAA010Banner } from '../../../services/Api';
import CheckBox from '../../../shared/components/Checkbox';
import Dropdown from '../../../shared/components/Dropdown';
import Nav from '../../../shared/components/Nav';

import PaginationCustom from '../../../shared/components/PaginationCustom';
import RecruitList from '../../../shared/components/RecruitList';
import GrandBanner from '../../../shared/GrandBanner';
import { MENU_RECRUIT, MESSAGE } from '../../../shared/constants/app';
import { decodeToken, getCheckBoxValues, getDropdownValue, getRadioBoxValue } from '../../../utils';
import PAEAA060 from '../PAEAA010/popupPAEAA060';

const PAEAA013 = () => {
    const [loading, setLoading] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);
    const login = useSelector(({ auth }) => auth.login);
    const loggedIn = login.loggedIn;
    const navigate = useNavigate();
    const [recruitLicenses, setRecruitLicenses] = useState([]);
    const [recruitForms, setRecruitForms] = useState([]);
    const [recruitPositions, setRecruitPositions] = useState([]);
    const [recruitPays, setRecruitPays] = useState([]);
    const [recruitDays, setRecruitDays] = useState([]);
    const [checkedLabels, setCheckedLabels] = useState([]);

    const [recruitClass, setRecruitClass] = useState([]);
    const [recruitProvinces, setRecruitProvinces] = useState([]);
    const [recruitCommunes, setRecruitCommunes] = useState({});
    const [selectedProvince, setSelectedProvince] = useState(null);

    // const [startDate, setStartDate] = useState('');
    // const [endDate, setEndDate] = useState('');
    const [checkedValues, setCheckedValues] = useState({});
    const [checkedLikeRightValues, setCheckedLikeRightValues] = useState({});
    const [applyMethod, setApplyMethod] = useState({});

    const [results, setResults] = useState([]);
    const [size, setSize] = useState(50);
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [sortBy, setSortBy] = useState('ModDate');

    const [conditionSearch, setConditionSearch] = useState('CompanyName');
    const [keywords, setKeywords] = useState([]);

    const dispatch = useDispatch();

    const savedConditions = useSelector(({ PAEAA010 }) => PAEAA010.savedPAEAA010Conditions);
    const [savedConditionsPopup, setSavedConditionsPopup] = useState(false);
    const popupRef = useRef(null);

    const [recruitBanner, setRecruitBanner] = useState([]);
    const [searchSuccess, setSearchSuccess] = useState(false);
    const [dataConFig, setDataConFig] = useState({
        countFixed: '',
        bannerConfig: '',
    });
    useEffect(() => {
        getPAAAA010recruit()
            .then(({ data }) => {
                setRecruitBanner(data.recruit);
                const listSeq = [data.recruit?.map((item) => item.seq).join(',')].filter((seq) => seq).join(',');
                if (listSeq.toString() === '') return;
                putPAAAA010Banner(listSeq.toString())
                    .then()
                    .catch((error) => console.log(error));
            })
            .catch((error) => console.log(error));
    }, []);

    const getOptions = (name) => {
        const options = {
            RecruitLicense: recruitLicenses.map((license) => ({
                id: 'recruitLicenses_' + license.code,
                label: license.codeName,
                value: license.code,
            })),

            RecruitForm: recruitForms.map((form) => ({
                id: 'recruitForms_' + form.code,
                label: form.codeName,
                value: form.code,
            })),

            RecruitPosition: recruitPositions.map((position) => ({
                id: 'recruitPositions_' + position.code,
                label: position.codeName,
                value: position.code,
            })),

            RecruitPay: recruitPays.map((pay) => ({
                id: 'recruitPays_' + pay.code,
                label: pay.codeName,
                value: pay.code,
            })),

            RecruitCareer: [
                { id: 'recruitCareers_999', value: '무관', label: '무관' },
                { id: 'recruitCareers_001', value: '신입', label: '신입' },
                { id: 'recruitCareers_009', value: '경력', label: '경력' },
            ],

            Assist1: [
                { id: 'assist1_101', value: '101', label: '기숙사지원' },
                { id: 'assist1_102', value: '102', label: '식대지원' },
            ],

            Assist2: [{ id: 'assist2_201', value: '201', label: '경조사지원' }],

            Assist3: [
                { id: 'assist3_301', value: '301', label: '자기계발비지원' },
                { id: 'assist3_302', value: '302', label: '연월차지원' },
                { id: 'assist3_303', value: '303', label: '휴가비지원' },
            ],
            Assist4: [{ id: 'assist4_401', value: '401', label: '4대보험지원' }],

            Assist5: [
                { id: 'assist5_501', value: '501', label: '연봉제' },
                { id: 'assist5_502', value: '502', label: '인센티브제' },
                { id: 'assist5_503', value: '503', label: '퇴직금지원' },
                { id: 'assist5_504', value: '504', label: '야근수당지원' },
                { id: 'assist5_505', value: '505', label: '기타' },
            ],

            RecruitDay: recruitDays.map((day) => ({
                id: 'recruitDays_' + day.code,
                label: day.codeName,
                value: day.code,
            })),

            ApplyMethod: [
                { id: 'ApplyMethod1', label: '온라인 즉시지원', value: '001' },
                { id: 'ApplyMethod2', label: '전화접수', value: '002' },
                { id: 'ApplyMethod3', label: '이메일접수', value: '003' },
                { id: 'ApplyMethod4', label: 'FAX접수', value: '004' },
                { id: 'ApplyMethod5', label: '우편접수', value: '005' },
            ],

            RecruiteCareerYear: [
                { value: '1', option: '1년' },
                { value: '2', option: '2년' },
                { value: '3', option: '3년' },
                { value: '4', option: '4년' },
                { value: '5', option: '5년' },
                { value: '6', option: '6년' },
                { value: '7', option: '7년' },
                { value: '8', option: '8년' },
                { value: '9', option: '9년' },
                { value: '10', option: '10년' },
                { value: '11', option: '11년' },
                { value: '12', option: '12년' },
                { value: '13', option: '13년' },
                { value: '14', option: '14년' },
                { value: '15', option: '15년' },
                { value: '16', option: '16년' },
                { value: '17', option: '17년' },
                { value: '18', option: '18년' },
                { value: '19', option: '19년' },
                { value: '20', option: '20년' },
                { value: '21', option: '21년' },
                { value: '22', option: '22년' },
                { value: '23', option: '23년' },
                { value: '24', option: '24년' },
                { value: '25', option: '25년' },
                { value: '26', option: '26년' },
                { value: '27', option: '27년' },
                { value: '28', option: '28년' },
                { value: '29', option: '29년' },
                { value: '30', option: '30년' },
            ],
        };
        return options[name];
    };

    // dropdown
    const handleOptionChange = (selectedValue, name) => {
        switch (name) {
            case 'size':
                setSize(selectedValue);
                break;
            case 'sortBy':
                setSortBy(selectedValue);
                break;
            case 'conditionSearch':
                setConditionSearch(selectedValue);
                break;
            default:
                setCheckedValues((checkedValues) => getDropdownValue(checkedValues, name, selectedValue));
                break;
        }
    };

    // select box, radio box
    const handleInputChange = (e) => {
        const { name, value, checked, type, id } = e.target;

        setCheckedValues((checkedValues) => {
            let newCheckedValues = { ...checkedValues };

            if (type === 'checkbox' && name !== 'ApplyMethod') {
                // lấy value checkbox
                newCheckedValues = getCheckBoxValues(newCheckedValues, name, value, checked);

                // kiểm tra nếu là RegionGu, cập nhật RegionSi tương ứng
                if (name === 'RegionGu') {
                    const selectedRegionSi = Object.entries(recruitCommunes).find(([key, communes]) =>
                        communes.some((commune) => commune.code === value),
                    );

                    if (selectedRegionSi) {
                        const [regionSiCode] = selectedRegionSi;
                        const currentRegionSi = newCheckedValues.RegionSi || [];
                        const currentRegionGu = newCheckedValues.RegionGu || [];

                        if (checked) {
                            if (value.endsWith('00')) {
                                const regionGuCodes =
                                    recruitCommunes[regionSiCode]?.map((commune) => commune.code) || [];
                                newCheckedValues.RegionGu = currentRegionGu.filter(
                                    (guCode) => !regionGuCodes.includes(guCode),
                                );
                                newCheckedValues.RegionGu.push(value);
                            } else {
                                const regionGuEndingWith00 = currentRegionGu.find((guCode) => guCode.endsWith('00'));
                                if (regionGuEndingWith00) {
                                    newCheckedValues.RegionGu = currentRegionGu.filter(
                                        (guCode) => guCode !== regionGuEndingWith00,
                                    );
                                }

                                if (!newCheckedValues.RegionGu.includes(value)) {
                                    newCheckedValues.RegionGu.push(value);
                                }
                            }

                            if (!currentRegionSi.includes(regionSiCode)) {
                                newCheckedValues.RegionSi = [...currentRegionSi, regionSiCode];
                            }
                        } else {
                            newCheckedValues.RegionGu = currentRegionGu.filter((guCode) => guCode !== value);

                            const remainingRegionGu = newCheckedValues.RegionGu || [];
                            const isRegionSiStillRelevant = recruitCommunes[regionSiCode]?.some((commune) =>
                                remainingRegionGu.includes(commune.code),
                            );

                            if (!isRegionSiStillRelevant) {
                                newCheckedValues.RegionSi = currentRegionSi.filter((code) => code !== regionSiCode);
                                if (newCheckedValues.RegionSi.length === 0) {
                                    delete newCheckedValues.RegionSi;
                                }
                            }
                        }
                    }
                }
            } else if (type === 'radio') {
                // lấy value radio
                // trường hợp đặc biệt cho `recruitCareer`
                if (name === 'RecruitCareer' && value !== '경력') {
                    // nếu không phải '경력': reset expMin và expMax
                    delete newCheckedValues.expMin;
                    delete newCheckedValues.expMax;
                }
                newCheckedValues = getRadioBoxValue(newCheckedValues, name, value, checked);
            }

            return newCheckedValues;
        });

        setApplyMethod((prevApplyMethod) => {
            let newApplyMethod = { ...prevApplyMethod };

            if (type === 'checkbox' && name === 'ApplyMethod') {
                const methodId = id;

                if (checked) {
                    if (!newApplyMethod[methodId]) {
                        newApplyMethod[methodId] = [];
                    }

                    if (!newApplyMethod[methodId].includes(value)) {
                        newApplyMethod[methodId].push(value);
                    }
                } else {
                    if (newApplyMethod[methodId]) {
                        newApplyMethod[methodId] = newApplyMethod[methodId].filter((item) => item !== value);

                        // Nếu không còn value nào, xóa key methodId
                        if (newApplyMethod[methodId].length === 0) {
                            delete newApplyMethod[methodId];
                        }
                    }
                }
            }

            return newApplyMethod;
        });
    };

    // tab 1
    useEffect(() => {
        if (recruitProvinces.length > 0) {
            setSelectedProvince(recruitProvinces[0].code);
        }
    }, [recruitProvinces]);

    const handleProvinceClick = (code) => {
        setSelectedProvince(code);
    };

    const communesToRender = recruitCommunes[selectedProvince] || [];

    const handleInputKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();

            const inputValue = e.target.value.trim();
            const inputName = e.target.name;

            if (inputValue) {
                if (keywords.length >= 3) {
                    return;
                }

                setCheckedLikeRightValues((prevValues) => {
                    const newValues = { ...prevValues };

                    if (inputName === 'searchAll') {
                        // thêm inputValue vào 'CompanyName', 'Title', và 'FTS_Contents'
                        ['CompanyName', 'Title', 'FTS_Contents'].forEach((key) => {
                            if (!newValues[key]) {
                                newValues[key] = [];
                            }

                            // thêm giá trị vào khóa tương ứng nếu nó chưa có ở đó
                            if (!newValues[key].includes(inputValue)) {
                                newValues[key].push(inputValue);
                            }
                        });
                    } else {
                        if (!newValues[conditionSearch]) {
                            newValues[conditionSearch] = [];
                        }
                        const updatedKeywords = [...newValues[conditionSearch], inputValue];
                        newValues[conditionSearch] = [...new Set(updatedKeywords)];
                    }

                    return newValues;
                });

                setKeywords((prevKeywords) => {
                    const updatedKeywords = [...prevKeywords, inputValue];
                    return [...new Set(updatedKeywords)];
                });

                e.target.value = '';
            }
        }
    };

    // get label
    const getCheckedLabels = () => {
        const labels = [];
        // lấy label từ checkedLikeRightValues
        Object.entries(checkedLikeRightValues).forEach(([key, values]) => {
            if (key === 'RecruitClass') {
                const valueArray = Array.isArray(values) ? values : [values];
                valueArray.forEach((code) => {
                    const recruit = recruitClass?.find((item) => item.code === code);

                    if (recruit) {
                        labels.push(recruit.codeName);
                    }
                });
            }
        });

        // lấy label từ checkedValues
        Object.entries(checkedValues).forEach(([key, values]) => {
            if (key === 'RegionGu') {
                const valueArray = Array.isArray(values) ? values : [values];

                valueArray.forEach((value) => {
                    // tìm RegionSi chứa RegionGu này
                    const regionSiEntry = Object.entries(recruitCommunes)?.find(([regionSiCode, communes]) =>
                        communes.some((commune) => commune.code === value),
                    );

                    if (regionSiEntry) {
                        const [regionSiCode] = regionSiEntry;

                        // tìm tên RegionSi từ recruitProvinces
                        const regionSi = recruitProvinces.find((province) => province.code === regionSiCode);

                        // tìm thông tin RegionGu
                        const commune = recruitCommunes[regionSiCode]?.find((commune) => commune.code === value);

                        if (regionSi && commune) {
                            labels.push(`${regionSi.codeName} > ${commune.codeName}`);
                        }
                    }
                });
            }
            const options = getOptions(key);
            const expMin = checkedValues.ExpMin !== undefined ? checkedValues.ExpMin + '년' : '';
            const expMax = checkedValues.ExpMax !== undefined ? checkedValues.ExpMax + '년' : '';

            if (!options) return;

            const valueArray = Array.isArray(values) ? values : [values];
            valueArray.forEach((value) => {
                const matchedOption = options?.find((option) => option.value === value);
                if (matchedOption) {
                    if (key === 'RecruitCareer' && value === '경력') {
                        labels.push(`경력: ${expMin} ~ ${expMax}`);
                    } else {
                        labels.push(matchedOption.option || matchedOption.label); // Dùng option nếu có
                    }
                }
            });
        });

        // lấy label từ applyMethod
        const flatApplyMethodValues = Object.values(applyMethod).flat();
        flatApplyMethodValues.forEach((value) => {
            const options = getOptions('ApplyMethod');

            const matchedOption = options.find((option) => option.value === value);

            if (matchedOption) {
                labels.push(matchedOption.label);
            }
        });

        if (keywords && keywords.length > 0) {
            keywords.forEach((keyword) => {
                labels.push(keyword);
            });
        }

        return labels;
    };

    // remove label
    const handleRemoveLabel = (label) => {
        setCheckedValues((prevValues) => {
            const newValues = { ...prevValues };

            const [regionSiName, regionGuName] = label.split(' > ');

            // duyệt qua các key trong checkedValues
            Object.entries(newValues).forEach(([key, values]) => {
                const options = getOptions(key);

                // xử lý xóa RecruitCareer với giá trị '경력'
                if (key === 'RecruitCareer' && label.startsWith('경력:')) {
                    // xóa expMin và expMax khi label là dạng 경력: X ~ Y
                    delete newValues.ExpMin;
                    delete newValues.ExpMax;
                    delete newValues[key];
                    return;
                }

                // xử lý RegionGu
                if (key === 'RegionGu') {
                    // tìm RegionSi liên kết với RegionGu từ recruitCommunes
                    const matchedCommune = Object.entries(recruitCommunes).find(([regionSiCode, communes]) => {
                        const regionSi = recruitProvinces.find((province) => province.code === regionSiCode);
                        return (
                            regionSi &&
                            regionSi.codeName === regionSiName &&
                            communes.some((commune) => commune.codeName === regionGuName)
                        );
                    });

                    if (matchedCommune) {
                        const [regionSiCode, communes] = matchedCommune;

                        // loại bỏ RegionGu được chọn khỏi checkedValues
                        const communeToRemove = communes.find((commune) => commune.codeName === regionGuName);
                        if (communeToRemove) {
                            newValues.RegionGu = newValues.RegionGu.filter((code) => code !== communeToRemove.code);
                            // nếu RegionGu trống, xóa luôn key RegionGu
                            if (newValues.RegionGu.length === 0) {
                                delete newValues.RegionGu;
                            }

                            // kiểm tra nếu RegionSi còn liên kết với các RegionGu khác
                            const remainingRegionGu = newValues.RegionGu || [];
                            const isRegionSiStillRelevant = communes.some((commune) =>
                                remainingRegionGu.includes(commune.code),
                            );

                            if (!isRegionSiStillRelevant) {
                                // loại bỏ RegionSi nếu không còn liên kết
                                newValues.RegionSi = (newValues.RegionSi || []).filter((code) => code !== regionSiCode);

                                if (newValues.RegionSi.length === 0) {
                                    delete newValues.RegionSi;
                                }
                            }
                        }
                    }
                }

                // xử lý các giá trị khác
                if (!options) return;

                // tìm value tương ứng với label
                const matchedOption = options.find((option) => option.label === label);
                if (matchedOption) {
                    if (Array.isArray(values)) {
                        // nếu là mảng (checkbox), loại bỏ giá trị tương ứng
                        newValues[key] = values.filter((value) => value !== matchedOption.value);
                        if (newValues[key].length === 0) {
                            delete newValues[key];
                        }
                    } else if (values === matchedOption.value) {
                        // nếu là giá trị đơn (radio, select), đặt lại giá trị
                        delete newValues[key];
                    }
                }
            });
            return newValues;
        });

        setCheckedLikeRightValues((prevValues) => {
            const newValues = { ...prevValues };
            // xóa dữ liệu trong checkedLikeRightValues
            Object.entries(prevValues).forEach(([key, values]) => {
                if (key === 'RecruitClass') {
                    values.forEach((code, index) => {
                        const recruit = recruitClass.find((item) => item.code === code && item.codeName === label);

                        if (recruit) {
                            newValues['RecruitClass'] = [...values.slice(0, index), ...values.slice(index + 1)];
                        }
                    });
                    if (newValues['RecruitClass'].length === 0) {
                        delete newValues['RecruitClass'];
                    }
                }
            });

            return newValues;
        });

        setApplyMethod((prevValues) => {
            const newValues = { ...prevValues };
            const options = getOptions('ApplyMethod');

            Object.entries(newValues).forEach(([key, values]) => {
                const valueArray = Array.isArray(values) ? values : [values];

                const matchedOption = options.find((option) => valueArray.includes(option.value));

                if (matchedOption && matchedOption.label === label) {
                    delete newValues[key];
                }
            });

            return newValues;
        });

        // xóa khỏi keywords và các trường 'CompanyName', 'Title', 'FTS_Contents'
        const isKeywordLabel = label && keywords.includes(label); // kiểm tra có trong keywords list không

        if (isKeywordLabel) {
            // xóa keyword khỏi `keywords` state
            const keywordToRemove = label;

            setKeywords((prevKeywords) => {
                return prevKeywords.filter((keyword) => keyword !== keywordToRemove);
            });

            // xóa keyword khỏi `CompanyName`, `Title`, `FTS_Contents` trong checkedLikeRightValues
            setCheckedLikeRightValues((prevValues) => {
                const newValues = { ...prevValues };

                ['CompanyName', 'Title', 'FTS_Contents'].forEach((field) => {
                    if (newValues[field]) {
                        // loại bỏ keyword khỏi các trường này
                        newValues[field] = newValues[field].filter((value) => value !== keywordToRemove);

                        // nếu trường trống sau khi xóa keyword, xóa luôn key đó
                        if (newValues[field].length === 0) {
                            delete newValues[field];
                        }
                    }
                });

                return newValues;
            });
        }

        // xóa label khỏi danh sách `checkedLabels`
        setCheckedLabels((prevLabels) => prevLabels.filter((l) => l !== label));
    };

    useEffect(() => {
        if (loggedIn) {
            dispatch(fetchInitialConditions());
        }
    }, [dispatch, loggedIn]);

    const handleSaveConditions = () => {
        if (window.location.pathname !== '/login' && window.location.pathname !== '/' && !loggedIn) {
            if (window.confirm(`회원전용입니다.\n로그인 하신후 이용하실 수 있습니다.\n로그인하시겠습니까?`)) {
                navigate('/login');
            } else {
                alert(`회원이 아닌경우 회원가입후 이용가능합니다.`);
                navigate('/');
            }
            return;
        }
        const savedDate = moment().format('YYYY/MM/DD');
        if (
            checkedLikeRightValues &&
            Object.keys(checkedLikeRightValues).length === 0 &&
            Object.keys(checkedValues).length === 0 &&
            Object.keys(applyMethod).length === 0 &&
            checkedLabels.length === 0
        )
            return;
        dispatch(
            saveFilterPAEAA010Conditions({
                checkedLikeRightValues,
                checkedValues,
                applyMethod,
                savedDate,
                checkedLabels,
            }),
        );

        dispatch(saveMatchingConditions(decode.seq));

        window.alert(MESSAGE.notify.saveSuccess);
    };

    const handleResetConditions = () => {
        setCheckedLikeRightValues({});
        setCheckedValues({});
        setCheckedLabels([]);
        setKeywords([]);
        setApplyMethod({});
    };

    useEffect(() => {
        setCheckedLabels(getCheckedLabels);
        // eslint-disable-next-line
    }, [checkedValues, checkedLikeRightValues, recruitClass]);

    useEffect(() => {
        getPAEAA010search()
            .then(({ data }) => {
                setRecruitProvinces(data.recruitProvinces);
                setRecruitCommunes(data.recruitCommunes);
                setRecruitLicenses(data.recruitLicense);
                setRecruitForms(data.recruitForm);
                setRecruitPositions(data.recruitPosition);
                setRecruitPays(data.recruitPay);
                setRecruitClass(data.recruitClass);
                setRecruitDays(data.recruitDay);
            })
            .catch((error) => console.log(error));
    }, []);

    const getListData = (currentPage = page) => {
        setLoading(true);
        setResults([]);
        // const startDateFormat = startDate === '' ? null : moment(startDate).format('yyyy-MM-DD');
        // const endDateFormat = endDate === '' ? null : moment(endDate).format('yyyy-MM-DD');
        let options =
            checkedValues && Object.keys(checkedValues).length === 0
                ? null
                : Object.fromEntries(
                    Object.entries(checkedValues).map(([key, value]) =>
                        key === 'RegionGu'
                            ? ['RegionGu', value]
                            : key === 'RegionSi'
                                ? ['RegionSi', value]
                                : [key, value],
                    ),
                );
        const optionLikeRight = Object.keys(checkedLikeRightValues).length === 0 ? null : checkedLikeRightValues;
        const method = Object.keys(applyMethod).length === 0 ? null : applyMethod;
        if (options && Array.isArray(options.RegionGu)) {
            const filteredRegionGu = options.RegionGu.filter((value) => {
                const numValue = parseInt(value);
                const isDivisibleBy100 = Number.isInteger(numValue) && numValue % 100 === 0;
                const endsWithZeros = value.endsWith('00');
                return !isDivisibleBy100 && !endsWithZeros;
            });

            if (filteredRegionGu.length === 0) {
                const { RegionGu, ...restOptions } = options;
                options = Object.keys(restOptions).length === 0 ? null : restOptions;
            } else {
                options = { ...options, RegionGu: filteredRegionGu };
            }
        }
        postPAEAA010list({
            options,
            optionLikeRight,
            applyMethod: method,
            // startDate: startDateFormat,
            // endDate: endDateFormat,
            size,
            page: currentPage,
            sortBy,
        })
            .then(({ data }) => {
                setResults(data.data.list);
                setPages(data.info);
                setDataConFig({
                    countFixed: data.data.countFixed,
                    bannerConfig: data.data.bannerConfig,
                });
            })
            .catch((error) => console.log(error))
            .finally(() => {
                setLoading(false);
                setSearchSuccess(true);
                setTimeout(() => setSearchSuccess(false), 2000);
            });
    };

    const handleSearchClick = () => {
        setSearchParams({ ...searchParams, page: 1 });
        getListData(1);
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page, size, sortBy]);

    const handleSelectSavedCondition = (index) => {
        const item = savedConditions[index];
        if (!item) return;

        const {
            checkedStoreValues,
            checkedLikeRightStoreValues,
            // startStoreDate,
            // endStoreDate,
            checkedStoreLabels,
            applyMethodStore,
        } = item;

        setCheckedValues(checkedStoreValues);
        setCheckedLikeRightValues(checkedLikeRightStoreValues);
        // setStartDate(startStoreDate);
        // setEndDate(endStoreDate);
        setCheckedLabels(checkedStoreLabels);
        setApplyMethod(applyMethodStore);

        const keywordSet = new Set();
        if (checkedLikeRightStoreValues && !checkedLikeRightStoreValues['RecruitClass']) {
            Object.values(checkedLikeRightStoreValues).forEach((keywords) => {
                keywords.forEach((keyword) => keywordSet.add(keyword));
            });
        }
        setKeywords([...keywordSet]);
    };
    const handleClickOutSidePopup = (e) => {
        if (popupRef.current && !popupRef.current.contains(e.target)) {
            setSavedConditionsPopup(false);
        }
    };

    useEffect(() => {
        if (savedConditionsPopup) {
            document.addEventListener('mousedown', handleClickOutSidePopup);
            return () => {
                document.removeEventListener('mousedown', handleClickOutSidePopup);
            };
        }
    }, [savedConditionsPopup]);

    const openPopup = (data) => {
        if (decode?.authorities === 'ROLE_P') {
            setPopupData(data);
            setIsPopupOpen(true);
        } else if (decode?.authorities === 'ROLE_C') {
            window.alert('개인회원만 이용가능합니다.');
        } else {
            window.alert('로그인 후 이용가능합니다.');
        }
    };

    const closePopup = () => {
        setPopupData(null);
        setIsPopupOpen(false);
    };

    return (
        <>
            <div id="content">
                <Nav menu={MENU_RECRUIT} />
                <div id="tabs-form" className="container">
                    <div className="top-form">
                        <h2>지역별</h2>
                        <div ref={popupRef}>
                            <button
                                id="saved-conditions"
                                data-type="popup"
                                onClick={() => {
                                    if (
                                        window.location.pathname !== '/login' &&
                                        window.location.pathname !== '/' &&
                                        !loggedIn
                                    ) {
                                        if (
                                            window.confirm(
                                                `회원전용입니다.\n로그인 하신후 이용하실 수 있습니다.\n로그인하시겠습니까?`,
                                            )
                                        ) {
                                            navigate('/login');
                                        } else {
                                            alert(`회원이 아닌경우 회원가입후 이용가능합니다.`);
                                            navigate('/');
                                        }
                                    }
                                    setSavedConditionsPopup(!savedConditionsPopup);
                                }}
                            >
                                <span>저장한 조건 보기</span>
                                <i className="icon icon-down" />
                            </button>
                            <div className={`popup ${savedConditionsPopup ? 'active' : ''}`} htmlFor="saved-conditions">
                                <button
                                    className="popup-close"
                                    onClick={() => {
                                        setSavedConditionsPopup(false);
                                    }}
                                />
                                <div className="popup-header">
                                    최근 저장한 검색 조건<span>(보관은 최대 5개까지 가능)</span>
                                </div>
                                <div className="popup-content">
                                    <ul className="table table-content">
                                        <li className="row-name-column">
                                            <div className="column start">검색조건</div>
                                            <div className="column start">검색일</div>
                                            <div className="column">삭제</div>
                                        </li>
                                        {savedConditions.map((item, index) => (
                                            <li key={index} onClick={() => handleSelectSavedCondition(index)}>
                                                <ul className="wrap-link">
                                                    {Array.isArray(item.checkedStoreLabels) &&
                                                        item.checkedStoreLabels.map((label, index) => (
                                                            <li key={index}>{label}</li>
                                                        ))}
                                                </ul>
                                                <span className="date">{item.savedStoreDate}</span>
                                                <button
                                                    className="delete"
                                                    onClick={() => {
                                                        dispatch(deleteFilterPAEAA010Conditions(index));
                                                        dispatch(saveMatchingConditions(decode.seq));
                                                    }}
                                                >
                                                    <i className="icon icon-trash"></i>
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* tab */}
                    <div className="tab tabs-select show-tab tabs-select--none">
                        <div className="tabs-flex">
                            <div className="tabs-left">
                                <ul>
                                    {recruitProvinces.map((province, index) => (
                                        <li
                                            className={province.code === selectedProvince ? 'active' : ''}
                                            key={index}
                                            onClick={() => handleProvinceClick(province.code)}
                                        >
                                            <span className="city-name">{province.codeName}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="tabs-right">
                                <form>
                                    {communesToRender.length > 0 && (
                                        <>
                                            <p className="notification">
                                                지역은 최대 <span>10</span>개까지 선택 가능합니다.
                                            </p>
                                            <ul>
                                                <CheckBox
                                                    name="RegionGu"
                                                    options={communesToRender.map((commune) => ({
                                                        id: 'regionGu_' + commune.code,
                                                        value: commune.code,
                                                        label: `${commune.codeName}`,
                                                    }))}
                                                    onChange={handleInputChange}
                                                    checked={checkedValues}
                                                />
                                            </ul>
                                        </>
                                    )}
                                </form>
                            </div>
                        </div>
                        <div className="bsns-srch">
                            <Dropdown
                                placeholder=""
                                options={[
                                    { value: 'CompanyName', option: '치과명' },
                                    { value: 'Title', option: '제목' },
                                    { value: 'FTS_Contents', option: '내용' },
                                ]}
                                value={conditionSearch}
                                name="conditionSearch"
                                onChange={handleOptionChange}
                            />
                            <input type="text" placeholder="검색어 입력하세요" onKeyPress={handleInputKeyPress} />
                        </div>
                    </div>

                    <div className="tab-select-results">
                        <ul className="results-area">
                            {checkedLabels.map((label, index) => (
                                <li key={index}>
                                    <div className="item-search">{label}</div>
                                    <span
                                        className="item-remove icon icon-x"
                                        onClick={() => handleRemoveLabel(label)}
                                    ></span>
                                </li>
                            ))}
                        </ul>
                        <div className="wrap-option-search-block">
                            <button
                                onClick={handleSearchClick}
                                disabled={loading}
                                style={{
                                    position: 'relative',
                                    opacity: loading ? 0.85 : 1,
                                    transition: 'all 0.2s',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                }}
                            >
                                {loading ? (
                                    <>
                                        <span
                                            style={{
                                                display: 'inline-block',
                                                width: '14px',
                                                height: '14px',
                                                border: '2px solid rgba(255,255,255,0.4)',
                                                borderTop: '2px solid #fff',
                                                borderRadius: '50%',
                                                animation: 'spin 0.7s linear infinite',
                                                marginRight: '6px',
                                                verticalAlign: 'middle',
                                            }}
                                        />
                                        검색 중...
                                    </>
                                ) : searchSuccess ? (
                                    <>
                                        <span style={{ marginRight: '4px' }}>✓</span>
                                        검색 완료
                                    </>
                                ) : (
                                    <>
                                        선택한 조건으로<span>검색하기</span>
                                    </>
                                )}
                            </button>
                            <div className="wrap-option-search">
                                <div className="option-reset icon icon-reset" onClick={handleResetConditions}>
                                    조건 초기화
                                </div>
                                <div className="option-save icon icon-pin" onClick={handleSaveConditions}>
                                    조건 저장
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <GrandBanner />
                {/* Content Table */}
                <div id="support-now">
                    <div className="container">
                        <div className="wrap-table">
                            <div className="header-table-container">
                                <div className="top-table top-table--mt45">
                                    <div className="top-table-title">
                                        <h1>검색결과</h1>
                                        <span>Search Results 전체 {pages?.totalRow}건</span>
                                    </div>
                                    <div className="wrap-dropDown">
                                        <div className="count-results blue">즉시지원만 보기</div>
                                        <div className="dropDowns">
                                            <Dropdown
                                                placeholder=""
                                                options={[
                                                    { value: 'AddDate', option: '등록일순' },
                                                    { value: 'ModDate', option: '업데이트순' },
                                                    { value: 'RecruitEnd', option: '마감일순' },
                                                ]}
                                                name="sortBy"
                                                value={sortBy}
                                                onChange={handleOptionChange}
                                                className={'form-select-container--ver2'}
                                            />
                                            <Dropdown
                                                placeholder=""
                                                options={[
                                                    { value: 50, option: '50개씩 보기' },
                                                    { value: 80, option: '80개씩 보기' },
                                                    { value: 100, option: '100개씩 보기' },
                                                ]}
                                                name="size"
                                                value={size}
                                                onChange={handleOptionChange}
                                                className={'form-select-container--ver2'}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="table table-header">
                                    <div className="column column-1">치과명</div>
                                    <div className="column column-3">
                                        <div>
                                            제목/담당업무/위치
                                        </div>
                                        <div>경력/형태/자격증/수정</div>
                                        <div>마감일</div>
                                    </div>
                                </div>
                            </div>
                            <RecruitList
                                loading={loading}
                                results={results}
                                recruitBanner={recruitBanner}
                                dataConFig={dataConFig}
                                openPopup={openPopup}
                                setRecruitList={setResults}
                                page={page}
                            />

                            <PaginationCustom pages={pages} />
                        </div>
                    </div>
                </div>
            </div>
            {isPopupOpen && <PAEAA060 popupData={popupData} closePopup={closePopup} />}
        </>
    );
};
export default PAEAA013;
